import React from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

import {
  PROFILE_SECURITY_ACCENT_ORANGE,
  PROFILE_SECURITY_BORDER_COLOR,
  PROFILE_SECURITY_HEADING_COLOR,
  PROFILE_SECURITY_PRIMARY_SOFT,
  PROFILE_SECURITY_SUBTITLE_COLOR,
  PROFILE_SECURITY_WHITE
} from '../constants/profileSecurityConstants'
import {
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SUCCESS_TEXT,
  UI_COLOR_PRIMARY,
  UI_COLOR_TEXT_MUTED_LIGHT
} from '../../../../constants/uiColors'

export default function ProfileSecurityFeatureCard({
  eyebrow,
  title,
  description,
  icon: Icon,
  iconTone = 'primary',
  action
}) {
  const iconStyles =
    iconTone === 'success'
      ? { bgcolor: UI_COLOR_SUCCESS_SOFT, color: UI_COLOR_SUCCESS_TEXT }
      : iconTone === 'warning'
        ? { bgcolor: '#FFF4E5', color: PROFILE_SECURITY_ACCENT_ORANGE }
        : { bgcolor: PROFILE_SECURITY_PRIMARY_SOFT, color: UI_COLOR_PRIMARY }

  return (
    <Box
      sx={{
        bgcolor: PROFILE_SECURITY_WHITE,
        border: `1px solid ${PROFILE_SECURITY_BORDER_COLOR}`,
        borderRadius: '16px',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          px: { xs: 2, sm: 2.5 },
          py: 1.75,
          flexWrap: 'wrap'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '12px',
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0,
              ...iconStyles
            }}
          >
            <Icon sx={{ fontSize: 20 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '0.04em',
                color: UI_COLOR_TEXT_MUTED_LIGHT,
                textTransform: 'uppercase'
              }}
            >
              {eyebrow}
            </Typography>
            <Typography sx={{ fontSize: 15, fontWeight: 800, color: PROFILE_SECURITY_HEADING_COLOR }}>
              {title}
            </Typography>
          </Box>
        </Box>

        {action ? <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>{action}</Box> : null}
      </Box>

      <Divider sx={{ borderColor: PROFILE_SECURITY_BORDER_COLOR }} />

      <Box sx={{ px: { xs: 2, sm: 2.5 }, py: { xs: 2, sm: 2.25 } }}>
        <Typography sx={{ fontSize: 13.5, color: PROFILE_SECURITY_SUBTITLE_COLOR, lineHeight: 1.5 }}>
          {description}
        </Typography>
      </Box>
    </Box>
  )
}
